import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAOUlEQVR42pWOMQoAIAwD6+TuG1X8nJMf9IRsVqQHBxlKE7MgSbpkbDiULwpOXMrxg/O2Yn9VfEe6bGz2BMDS8C75AAAAAElFTkSuQmCC"};
